import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { getTemplateListQuery } from "./queries";

const EvalTemplate = createContext({});

export const useEvalTemplateContext = () => useContext(EvalTemplate);

export const EvalTemplateProvider = ({ ...props }) => {
  const [templateList, setTemplateList] = useState([]);

  const getTemplatesList = useCallback(async () => {
    try {
      if (templateList.length === 0) {
        setTemplateList(await getTemplateListQuery());
      }
    } catch (e) {
      console.error("getTemplatesList", e);
    }
  }, [templateList]);

  const values = useMemo(
    () => ({
      getTemplatesList,
      templateList,
    }),
    [templateList, getTemplatesList]
  );
  return <EvalTemplate.Provider value={values} {...props} />;
};
